import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { format, isValid } from 'date-fns';
import classes from './PatientHistorySelector.module.scss';

export type PatientHistoryItem = {
  patientPublicId: string;
  status: string;
  surgeryDate: string | null;
  createdAt: string;
};

type Props = {
  history: PatientHistoryItem[];
  currentPatient: PatientHistoryItem;
  selectedPatientId: string;
  loading: boolean;
  onChange: (patientPublicId: string) => void;
};

const formatDate = (value: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  return isValid(date) ? format(date, 'dd.MM.yyyy') : value;
};

export const PatientHistorySelector = ({
  history,
  currentPatient,
  selectedPatientId,
  loading,
  onChange,
}: Props) => {
  const versions = [
    ...history,
    ...(history.some(item => item.patientPublicId === currentPatient.patientPublicId)
      ? []
      : [currentPatient]),
  ].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  if (versions.length < 2 && !loading) return null;

  return (
    <FormControl className={classes.historySelector} size="small">
      <InputLabel id="patient-version-label">Patient version</InputLabel>
      <Select
        labelId="patient-version-label"
        label="Patient version"
        value={selectedPatientId}
        disabled={loading}
        onChange={event => onChange(event.target.value)}
      >
        {versions.map(version => (
          <MenuItem key={version.patientPublicId} value={version.patientPublicId}>
            {version.status || 'Unknown status'}
            {` · Created: ${formatDate(version.createdAt) ?? '-'}`}
            {` · Surgery date: ${formatDate(version.surgeryDate) ?? '-'}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
